import { axiosGet, axiosPost } from "./axiosFunctions";
import { getAuthState } from "../../assets/scripts/login-util";

const getClientsUrl         = '/api/tpa/dashboard/getClients';
const postClientUrl         = '/api/tpa/dashboard/postClient';
const postClientListUrl     = '/api/tpa/dashboard/postClientList';
const getClientDetailsUrl   = '/api/tpa/dashboard/getClientDetails';
const getMISUrl             = '/api/tpa/dashboard/getMIS';

export const getClientList = async(filters = {}) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    const params = {};

    if (filters.search) params.search = filters.search;
    if (filters.type && filters.type !== 'All') params.type = filters.type;
    if (filters.status && filters.status !== 'All') params.status = filters.status;
    
    const response = await axiosGet( getClientsUrl, { headers: { auth_token: `bearer ${token}` }, params } );
    return response;
}

export const postClient = async (client) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosPost(
        postClientUrl,
        { client },
        { headers: { auth_token: `bearer ${token}` }} 
    );
    return response;
};

export const postClientList = async (clients) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosPost(
        postClientListUrl,
        { clients },
        { headers: { auth_token: `bearer ${token}` }} 
    );
    return response;
};

export const getClientDetails = async (clientId) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet(   
        getClientDetailsUrl,        
        { headers: { auth_token: `bearer ${token}`},  params: { clientId }} 
    );
    return response;
};

export const getMIS = async() => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet( getMISUrl, { headers: { auth_token: `bearer ${token}` }} );
    return response;
}